/* global axios */
import BotifyAPI from './BotifyAPI';

class WooCommerce extends BotifyAPI {
  constructor() {
    super('woocommerce', { accountScoped: true });
  }

  prepareWebhook() {
    return (
      this.ensureConfigured() || axios.post(`${this.url}/webhook/prepare`, {})
    );
  }

  connect({
    url,
    consumerKey,
    consumerSecret,
    botId,
    webhookUuid,
    webhookSecret,
  }) {
    const guard = this.ensureConfigured();
    if (guard) return guard;

    if (
      !url ||
      !consumerKey ||
      !consumerSecret ||
      !botId ||
      !webhookUuid ||
      !webhookSecret
    ) {
      throw new Error(
        'url, consumerKey, consumerSecret, botId, webhookUuid, webhookSecret are required'
      );
    }
    const normalizedUrl = String(url)
      .trim()
      .replace(/\s+/g, '')
      .replace(/\/+$/, '');

    return axios.post(
      `${this.url}/connect`,
      {
        url: normalizedUrl,
        consumerKey,
        consumerSecret,
        botId,
        webhookUuid,
        webhookSecret,
      },
      {
        timeout: 20000,
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
  }

  testConnection({ url, consumerKey, consumerSecret }) {
    const guard = this.ensureConfigured();
    if (guard) return guard;

    if (!url || !consumerKey || !consumerSecret) {
      throw new Error('url, consumerKey, consumerSecret are required');
    }
    return axios.post(
      `${this.url}/test-connection`,
      { url, consumerKey, consumerSecret },
      { timeout: 15000 } // 15s
    );
  }

  getStatus() {
    return (
      this.ensureConfigured() ||
      axios.get(`${this.url}/status`, { timeout: 10000 })
    );
  }

  // POST /webhook/enable (form-data)
  enableWebhook({ webhookUrl, events } = {}) {
    const guard = this.ensureConfigured();
    if (guard) return guard;

    const fd = new FormData();
    if (webhookUrl) fd.append('webhookUrl', webhookUrl);
    (Array.isArray(events) ? events : []).forEach(ev =>
      fd.append('events', ev)
    );
    return axios.post(`${this.url}/webhook/enable`, fd);
  }

  disableWebhook() {
    return this.ensureConfigured() || axios.post(`${this.url}/webhook/disable`);
  }

  startSync({ full = false } = {}) {
    return this.ensureConfigured() || axios.post(`${this.url}/sync`, { full });
  }

  getSyncJobStatus(jobId) {
    const guard = this.ensureConfigured();
    if (guard) return guard;

    if (!jobId) throw new Error('jobId is required');
    return axios.get(`${this.url}/sync-job/${jobId}/status`);
  }

  retrySyncJob(jobId) {
    const guard = this.ensureConfigured();
    if (guard) return guard;

    if (!jobId) throw new Error('jobId is required');
    return axios.post(`${this.url}/sync-job/${jobId}/retry`);
  }

  deleteConnection() {
    return this.ensureConfigured() || axios.delete(`${this.url}/connection`);
  }

  getConnection() {
    return this.ensureConfigured() || axios.get(`${this.url}/connection`);
  }

  getProducts(params = {}) {
    return (
      this.ensureConfigured() || axios.get(`${this.url}/products`, { params })
    );
  }

  manualRecovery() {
    return (
      this.ensureConfigured() || axios.post(`${this.url}/recovery/manual`, {})
    );
  }
}

export default new WooCommerce();
